module.exports = __webpack_public_path__ + "img/bz5.10175719.png";